
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


document.addEventListener('DOMContentLoaded', function() {
    waitForElm('.singleProductPreOrderForm').then((elm) => {
        elm.closest('.hc-qty-buy-row').classList.add('hc-qty-buy-row--pre-order');
    });

    waitForElm('.product-grid__content .stamped-product-reviews-badge').then((elm) => {
        let starRating = elm;//.closest('[data-product-blocks]');
        let pdpInfoRow = document.querySelector('.hc-pro-info-row');
        
        pdpInfoRow.insertBefore(starRating, pdpInfoRow.firstChild);
    });
});